'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loader = exports.BatchLoader = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _map = require('babel-runtime/core-js/map');

var _map2 = _interopRequireDefault(_map);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// A minimal data loader which batches and caches requests
var BatchLoader = exports.BatchLoader = function () {
  function BatchLoader(_ref) {
    var _ref$autoDispatch = _ref.autoDispatch,
        autoDispatch = _ref$autoDispatch === undefined ? true : _ref$autoDispatch;
    (0, _classCallCheck3.default)(this, BatchLoader);

    // A queue of data requests which need to be fulfilled.
    this.promiseQueue = [];

    // A map of ids to extras and in-promise results.
    this.cache = new _map2.default();

    this.autoDispatch = autoDispatch;
  }

  // Checks whether something is in the cache. Override this to check whether
  // the extras are enough.


  (0, _createClass3.default)(BatchLoader, [{
    key: 'getFromCache',
    value: function getFromCache(id) {
      var cached = this.cache.get(id);
      if (!cached) {
        return null;
      }

      var promise = cached.promise;

      return promise;
    }
  }, {
    key: 'putCache',
    value: function putCache(id) {
      var extras = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var promise = arguments[2];

      this.cache.set(id, { extras: extras, promise: promise });
    }
  }, {
    key: 'load',
    value: function load(id) {
      var _this = this;

      var extras = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // try to get from cache
      var cached = this.getFromCache(id, extras);
      if (cached) {
        // cache hit
        return cached;
      }

      // enqueue get from remote
      var promise = new _promise2.default(function (resolve, reject) {
        _this.promiseQueue.push({ id: id, extras: extras, resolve: resolve, reject: reject });

        if (_this.promiseQueue.length === 1 && _this.autoDispatch) {
          // first element in the queue, schedule dispatch to run after the stack
          // is completely unwound and when the promise microtask queue is
          // executing. The procces.nextTick causes dispatch to run after the
          // promise microtask queue is exhausted. The promise microtask queue can
          // be added to by things on the promise microtask queue.

          _promise2.default.resolve().then(function () {
            return process.nextTick(function () {
              return _this.dispatch();
            });
          });
        }
      });

      // cache request
      this.putCache(id, extras, promise);

      return promise;
    }

    // Called by dispatch when it is time to load the batched queries. This method
    // is responsible for notifying promises about results and failures.

  }, {
    key: 'batchLoad',
    value: function batchLoad() {
      throw new TypeError('You need to implement this method.');
    }

    // Call when you want promises from load to be resolved.

  }, {
    key: 'dispatch',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var _this2 = this;

        var queue;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // pull and reset queue
                queue = this.promiseQueue;

                this.promiseQueue = [];

                _context.prev = 2;
                _context.next = 5;
                return this.batchLoad(queue);

              case 5:
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](2);

                // we encountered some kind of error, fail all promises
                queue.forEach(function (_ref3) {
                  var id = _ref3.id,
                      reject = _ref3.reject;

                  reject(_context.t0);

                  // remove from cache so the next time load is called, we fetch new data
                  _this2.cache.delete(id);
                });

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 7]]);
      }));

      function dispatch() {
        return _ref2.apply(this, arguments);
      }

      return dispatch;
    }()
  }]);
  return BatchLoader;
}();

// A minimal caching data loader which doesn't batch requests. It also supplies
// and extra parameter at cache try/put time.


var Loader = exports.Loader = function () {
  function Loader(_ref4) {
    var fetchFn = _ref4.fetchFn,
        _ref4$tryCacheFn = _ref4.tryCacheFn,
        tryCacheFn = _ref4$tryCacheFn === undefined ? this.tryCache : _ref4$tryCacheFn,
        _ref4$putCacheFn = _ref4.putCacheFn,
        putCacheFn = _ref4$putCacheFn === undefined ? this.putCache : _ref4$putCacheFn,
        cache = _ref4.cache;
    (0, _classCallCheck3.default)(this, Loader);

    this.cache = cache || new _map2.default();

    this.tryCache = tryCacheFn.bind(this);
    this.putCache = putCacheFn.bind(this);
    this.fetch = fetchFn.bind(this);
  }

  (0, _createClass3.default)(Loader, [{
    key: 'tryCache',
    value: function tryCache(id) {
      return this.cache.get(id);
    }
  }, {
    key: 'putCache',
    value: function putCache(id, extras, promise) {
      this.cache.set(id, promise);
    }
  }, {
    key: 'load',
    value: function load(id, extras) {
      var cached = this.tryCache(id, extras);
      if (cached) {
        return cached;
      }

      var promise = this.fetch(id, extras);
      this.putCache(id, extras, promise);
      return promise;
    }
  }]);
  return Loader;
}();


//////////////////
// WEBPACK FOOTER
// ./~/nice-sharebase/lib/loader.js
// module id = 548
// module chunks = 0